var _path, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCarouselRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1678 25.8418C15.1146 25.7918 15.0724 25.7324 15.0436 25.667C15.0148 25.6016 15 25.5315 15 25.4606C15 25.3898 15.0148 25.3197 15.0436 25.2543C15.0724 25.1889 15.1146 25.1295 15.1678 25.0795L21.6199 18.9999L15.1678 12.9203C15.0606 12.8192 15.0003 12.6821 15.0003 12.5391C15.0003 12.3961 15.0606 12.259 15.1678 12.1579C15.2751 12.0568 15.4206 12 15.5723 12C15.724 12 15.8695 12.0568 15.9768 12.1579L22.8322 18.6187C22.8854 18.6687 22.9276 18.7281 22.9564 18.7935C22.9852 18.8589 23 18.929 23 18.9999C23 19.0707 22.9852 19.1408 22.9564 19.2062C22.9276 19.2716 22.8854 19.331 22.8322 19.381L15.9768 25.8418C15.9237 25.892 15.8607 25.9317 15.7913 25.9589C15.7218 25.986 15.6474 26 15.5723 26C15.4972 26 15.4228 25.986 15.3533 25.9589C15.2839 25.9317 15.2209 25.892 15.1678 25.8418Z",
    fill: "#02F6AD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 37.5,
    y: 37.5,
    width: 37,
    height: 37,
    rx: 18.5,
    transform: "rotate(180 37.5 37.5)",
    stroke: "#02F6AD"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarouselRight);
export default __webpack_public_path__ + "static/media/carouselRight.2666f64b26e138f1a9264c8ba3737b33.svg";
export { ForwardRef as ReactComponent };